import { API_BASE_URL } from './api';

const AUTH_PROVIDER = import.meta.env.VITE_AUTH_PROVIDER || 'microsoft';
const LOCAL_LOGOUT_KEY = 'journiy.admin.local-logout';

export function isLocalLogout() {
  return window.sessionStorage.getItem(LOCAL_LOGOUT_KEY) === 'true';
}

export function clearLocalLogout() {
  window.sessionStorage.removeItem(LOCAL_LOGOUT_KEY);
}

function getCallbackUrl() {
  return `${window.location.origin}/auth/callback`;
}

export function login() {
  clearLocalLogout();
  const url = `${API_BASE_URL}/auth/${AUTH_PROVIDER}/login?callback=${encodeURIComponent(getCallbackUrl())}`;
  window.location.assign(url);
}

export async function exchangeCodeForToken(code, provider = AUTH_PROVIDER) {
  const response = await fetch(`${API_BASE_URL}/auth`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ code, provider, admin_caller: true }),
  });
  if (!response.ok) throw new Error(`Authentication exchange failed (${response.status})`);
  const profile = await response.json();
  if (profile?.role !== 'admin') {
    throw new Error('Administrator access is required.');
  }
  return profile;
}

export function logout() {
  window.sessionStorage.setItem(LOCAL_LOGOUT_KEY, 'true');
  if (import.meta.env.DEV) {
    window.location.assign('/');
    return;
  }
  window.location.assign(`${API_BASE_URL}/auth/${AUTH_PROVIDER}/logout`);
}
